const CUSTOMER_SUPPORT_TYPES = [{
  label: 'General Inquiry',
  value: 1,
  key: 1,
  icon: 'StoryFilled', // Generic, fits inquiry/discussion
  color: '#1976d2',
  background: 'rgba(144,202,249,0.16)'
}, {
  label: 'Account Issue',
  value: 2,
  key: 2,
  icon: 'SubtaskFilled', // Account-level sub-items
  color: '#5e35b1',
  background: 'rgba(209,196,233,0.16)'
}, {
  label: 'Billing Problem',
  value: 3,
  key: 3,
  icon: 'BugFilled', // For "problem"/issue
  color: '#c62828',
  background: 'rgba(255,171,145,0.16)'
}, {
  label: 'Technical Issue',
  value: 4,
  key: 4,
  icon: 'TaskFilled', // Tech tickets/tasks
  color: '#0288d1',
  background: 'rgba(144,202,249,0.16)'
}, {
  label: 'Product Complaint',
  value: 5,
  key: 5,
  icon: 'BugFilled', // Fits issues needing improvement
  color: '#ef6c00',
  background: 'rgba(255,224,178,0.16)'
}, {
  label: 'Refund Request',
  value: 6,
  key: 6,
  icon: 'FeatureRequestFilled', // Reuse; close to "request"
  color: '#2e7d32',
  background: 'rgba(165,214,167,0.16)'
}, {
  label: 'Order Status',
  value: 7,
  key: 7,
  icon: 'SupportFilled', // Support-style icon
  color: '#6d4c41',
  background: 'rgba(215,204,200,0.16)'
}, {
  label: 'Cancellation Request',
  value: 8,
  key: 8,
  icon: 'ChangerequestFilled', // Suitable for requests like cancellation
  color: '#d32f2f',
  background: 'rgba(255,138,128,0.16)'
}, {
  label: 'Feedback or Suggestion',
  value: 9,
  key: 9,
  icon: 'FeatureRequestFilled', // Closely related to suggestions
  color: '#00695c',
  background: 'rgba(128,222,234,0.16)'
}, {
  label: 'Feature Request',
  value: 10,
  key: 10,
  icon: 'FeatureRequestFilled',
  color: '#283593',
  background: 'rgba(197,202,233,0.16)'
}, {
  label: 'How-to Guidance',
  value: 11,
  key: 11,
  icon: 'EpicFilled', // Foundational, fits guidance
  color: '#7cb342',
  background: 'rgba(220,237,200,0.16)'
}, {
  label: 'Login/Access Issue',
  value: 12,
  key: 12,
  icon: 'BugFilled', // Reused — closest for access/login issues
  color: '#8e24aa',
  background: 'rgba(225,190,231,0.16)'
}, {
  label: 'Service Downtime',
  value: 13,
  key: 13,
  icon: 'TaskFilled', // Service-related task/alert
  color: '#f44336',
  background: 'rgba(255,205,210,0.16)'
}, {
  label: 'Data Correction Request',
  value: 14,
  key: 14,
  icon: 'ImprovementsFilled', // Fits correction or fix
  color: '#1565c0',
  background: 'rgba(144,202,249,0.16)'
}, {
  label: 'Subscription Issue',
  value: 15,
  key: 15,
  icon: 'SubtaskFilled', // Minor unit-level problem
  color: '#ff6f00',
  background: 'rgba(255,224,178,0.16)'
}, {
  label: 'Others',
  value: 16,
  key: 16,
  icon: 'StoryFilled', // Generic fallback
  color: '#607d8b',
  background: 'rgba(176,190,197,0.16)'
}];

export { CUSTOMER_SUPPORT_TYPES };
